import Axios from 'axios';

const BASE_URL = '/api/docs/';


export default {

    getTRpts(data) {
        return Axios.post(BASE_URL+'trpts',data);
    },
    getBills(data) {
        return Axios.post(BASE_URL+'bills',data);
    },
    getPerfRpt(data){
        return Axios.post(BASE_URL+'perfrpt',data);
    }


}



// WEBPACK FOOTER //
// ./resources/assets/js/services/docs.js